import { MuiTelInput } from "mui-tel-input";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";

export const MobileLogin = ({
    phoneNum = "",
    setPhoneNumber = () => {},
    control,
    name = "phone",
    style = {},
    disabled = false,
    placeholder,
}) => {
    const matchIsValidTel = (value) => {
        const SAPrefix = value?.slice(0, 5);
        if (!value) {
            return messages["mobile.required"];
        }

        // if (
        //   value &&
        //   SAPrefix?.trim() === "+966" &&
        //   value?.slice(5).startsWith("5") &&
        //   value?.slice(5)?.trim()?.length === 11
        // ) {
        //   return true;
        // } else if (value && SAPrefix?.trim() === "+966") {
        //   return messages["mobile.valid_saudi_number"];
        // } else if (value && SAPrefix?.trim() !== "+966") {
        //   return messages["mobile.valid_saudi_number"];
        // } else if (!value) {
        //   return messages["mobile.required"];
        // }
    };
    const { messages } = useIntl();

    return (
        <div className="mentor-input">
            <label className="mentor-input__label auth-label">
                {messages["mobile"]}
            </label>
            <Controller
                name={name}
                control={control}
                rules={{
                    validate: matchIsValidTel,
                }}
                render={({ field, fieldState }) => (
                    <>
                        <MuiTelInput
                            {...field}
                            disabled={disabled}
                            langOfCountryName="ar"
                            placeholder={placeholder}
                            className="phone-input"
                            defaultCountry="SA"
                            continents={["AF", "AS"]}
                            error={fieldState?.invalid}
                            InputLabelProps={{ shrink: false }}
                        />
                        {fieldState?.invalid && (
                            <span className="mentor-input__field-error">
                                {fieldState?.error?.message}
                            </span>
                        )}
                    </>
                )}
            />
        </div>
    );
};
